import * as React from 'react';
import { Field, reduxForm, change } from 'redux-form';
//import DEform from '../forms/DEform';
import * as FileSystem from 'expo-file-system';
import styles from './deFormStyles';
import { TouchableOpacity, Image, Switch, Platform, Picker as rnPicker, TextInput } from 'react-native';
import {
	Container,
	Header,
	InputGroup,
	Content,
	Text,
	Label,
	Input,
	Icon,
	Toast,
	Form,
	Spinner,
	View,
	Left,
	Right,
	Body,
	Button,
	Title,
	Card,
	CardItem,
	H3,
	ListItem,
	Picker as nbPicker
} from 'native-base';

import * as _ from 'lodash';

import FormFooter from '../components/formFooter';
import { textInput, moneyInput, renderPicker, renderDateField, picInput, renderSwitch, numberInput, displayInput, displaySelection, renderAutoComplete } from './renderedComponents';

import PersonForm from '../screens/PersonForm';
import ExpenseTypeContainer from '../screens/DEform/expenseTypeContainer';
import DECamera from '../screens/DEform/DECamera';

//import Moment from 'moment';

const formatMoney = value => value; //to display
const parseMoney = value => parseFloat(isNaN(value) ? 0 : value).toFixed(2); //to store

function syncValidate(values, props) {
	//runs while field changing
	var errors = {};
	//console.log(values);
	if (props.transType == 'receipt') {
		if (!values.takingCategory_id) errors.takingCategory_id = 'Required';
	} else {
		//expense
		if (!values.expenseCategory_id) errors.expenseCategory_id = 'Required';
	}
	/* EGs
	  if (!values.username) {
		errors.username = 'Required'
	  } else if (values.username.length > 15) {
		errors.username = 'Must be 15 characters or less'
	  }
	  if (!values.email) {
		errors.email = 'Required'
	  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
		errors.email = 'Invalid email address'
	  }
	  if (!values.age) {
		errors.age = 'Required'
	  } else if (isNaN(Number(values.age))) {
		errors.age = 'Must be a number'
	  } else if (Number(values.age) < 18) {
		errors.age = 'Sorry, you must be at least 18 years old'
	  }
	  */

	if (!values.description) errors.description = 'Required';
	if (parseFloat(values.paid) > 0 && values.account_id == 0) errors.account_id = 'Please select an account';

	return errors;
}

function asyncValidate(values, dispatch, props, field) {
	console.log('acsyncVal', arguments);
	/*

								if (field === 'userName') {
								return fetch("${apiUrl}/auth/validations/v1", {
									method: "POST",
									body: JSON.stringify({
										type: 'user-name',
										value: values.userName
									}),
									headers: new Headers({
										"Content-Type": "text/plain"
									})
								}).then(function (response) {
									return response.text();
								}).then(function (data) {
									const previousErrors = props.asyncErrors;
									if (data && (data === true || data === 'true')) {
										throw Object.assign({}, previousErrors, {[field]: 'b591d5f.0450d1b.76ae7b1.d'})
									}
								});
							}
							*/
	return new Promise((resolve, reject) => {
		//runs on BLUR for net, vat, payable, paid. So first update values
		var value = Number(values[field]);
		var Dispval = parseFloat(isNaN(value) ? 0 : value).toFixed(2);
		__DEV__ && console.log('changing ', field, Dispval);
		dispatch(change('DEform', field, Dispval));
		//console.log('asyncValidate', arguments, this);
		//reject('nope');
		/*((blur only)) path=payable and net=0. set net = gross / (1+ vatRate / 100);
										net not 0. set vat=(gross - net).toFixed(2)
			*/
		var vatRate = props.vatRate;
		var vatReg = props.vatReg;

		var net = parseFloat(values.net);
		var vat = parseFloat(values.vat);
		var gross = parseFloat(values.payable);
		var paid = parseFloat(values.paid);

		const bankImported = !!values.setransaction_id;

		if (field == 'net' && !!net) {
			if (vatReg) {
				var vat = (net * vatRate) / 100;
				dispatch(change('DEform', 'vat', vat.toFixed(2)));
				dispatch(change('DEform', 'payable', (net * (1 + vatRate / 100)).toFixed(2)));
				if (!bankImported) dispatch(change('DEform', 'paid', (net * (1 + vatRate / 100)).toFixed(2)));
			} //if not vatreg this is not shown so must have been programatically changed
		} else if (field == 'vat' && !!net && (!!vat || vat == 0)) {
			if (bankImported) {
				//change net
				dispatch(change('DEform', 'net', (gross - vat).toFixed(2)));
			} else {
				//change gross and paid
				dispatch(change('DEform', 'payable', (vat + net).toFixed(2)));
				dispatch(change('DEform', 'paid', (vat + net).toFixed(2)));
			}
		} else if (field == 'payable' && !!gross) {
			if (net && vat && gross > net) dispatch(change('DEform', 'vat', (gross - net).toFixed(2))) && resolve();
			if (net && vat && gross < net) dispatch(change('DEform', 'net', gross.toFixed(2))) && dispatch(change('DEform', 'vat', '0.00')) && resolve();
			if (!bankImported) dispatch(change('DEform', 'paid', gross.toFixed(2)));
		}

		if (props.accounts && props.isNew && !values.account_id) {
			console.log('componentDidUpdate');
			//find appropriate account - first current?
			const first = _.find(props.accounts, { accountType: '1' });
			if (first) dispatch(change('DEform', 'account_id', first.id));
		}

		resolve();
	});
}

class DEform extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			adding: false,
			expenseing: props.transType == 'expense' && props.isNew && !props.initialValues.expenseCategory_id,
			camming: false,
			pic: null,
			wantRecurring: false,
			periodNum: 1,
			periodFreq: 'M',
			addingName: null
		};
		this.state = this.initialState;
		this.formRefs = [];
		//console.log('DEForm - ', this.props, this);

		this.customers = [...this.props.customers];
		//if (this.customers && this.customers.length && this.customers[0].id) this.customers.unshift({ id: 0, display: ' - No Customer - ' });
		//this.suppliers = [...this.props.suppliers];
		//if (this.suppliers && this.suppliers.length && this.suppliers[0].id) this.suppliers.unshift({ id: 0, display: ' - No Supplier - ' });
		//this.categories = [...this.props.categories];
		//if (this.props.transType != 'receipt' && this.categories && this.categories.length && this.categories[0].id) this.categories.unshift({ id: 0, categoryName: ' - Choose Type - ' });
		//this.accounts = [...this.props.accounts];
		//if (this.accounts && this.accounts.length && this.accounts[0].id) this.accounts.unshift({ id: 0, nickName: ' - Choose Account - ', accountType: 0 });
	}

	makeForm(suppliers, customers, categories, accounts) {
		const formType = this.props.transType;
		this.formRefs = [];
		if (!formType) return <Spinner />;
		const { wantRecurring } = this.state;
		const { recurring, canRecur } = this.props;
		const Picker = Platform.OS == 'ios' ? nbPicker : rnPicker;

		if (formType == 'receipt') {
			return (
				<Form onSubmit={this.props.handleSubmit}>
					<Field name="expenseDate" component={renderDateField} />
					<Field name="takingCategory_id" component={renderPicker} icon="filing" prompt="Select category" mode="dropdown">
						{categories.map((item, i) => (
							<Picker.Item key={i} label={item.categoryName} value={item.id} />
						))}
					</Field>
					<Field name="description" icon="quote" component={textInput} placeholder="(Description)" autoFocus />
					{/*<View style={{ flexDirection: 'row' }}>
						<Field name="customer_id" component={renderPicker} icon="person" prompt="Select customer" mode="dropdown" emptyText=" - No customer - " allowEmpty>
							{customers.map((item, i) => (
								<Picker.Item key={i} label={item.display} value={item.id} />
							))}
						</Field>
						<Button transparent style={{ alignSelf: 'center' }} onPress={this._toggleModal}>
							<Icon name="person-add" style={styles.addPerson} />
						</Button>
					</View>*/}

					<Field icon="person" name="customer_id" emptyText=" - No customer - " component={renderAutoComplete} data={customers} openAdder={this._toggleModal} />

					{this.props.vatReg && <Field name="net" label="Net" icon="pricetag" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />}
					{this.props.vatReg && <Field name="vat" label="VAT" icon="cut" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />}
					<Field name="payable" label="Receivable" icon="pricetags" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />
					<Field name="paid" label="Received" icon="done-all" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} disabled={!!this.props.initialValues?.setransaction_id} />
					{!!this.props.showAccts && (
						<Field
							name="account_id"
							label={'To'}
							component={renderPicker}
							icon="open"
							labelWidth="30%"
							style={{ flex: 1 }}
							prompt="Select account"
							mode="dropdown"
							emptyText=" - Choose Account - "
							disabled={!!this.props.initialValues?.setransaction_id}>
							{accounts
								.filter(item => {
									return item.accountType < 2;
								})
								.map((item, i) => (
									<Picker.Item key={i} label={item.nickName} value={item.id} />
								))}
						</Field>
					)}
				</Form>
			);
		} else {
			//EXPENSE
			return (
				<Form onSubmit={this.props.handleSubmit}>
					<View style={{ flex: 1, flexDirection: 'row', marginBottom: 10 }}>
						<Field name="expenseDate" component={renderDateField} />
						<Field name="pic" component={picInput} onAdd={() => this.setState({ camming: true })} />
					</View>

					<Button transparent onPress={this._toggleExpenseTypes} style={{ width: '100%' }}>
						<Field name="expenseCategory_id" component={displaySelection} icon="filing" items={categories} displayProperty="categoryName" emptyText=" - Choose Type - " />
						<Icon name="search" style={styles.addPerson} />
					</Button>

					<Field name="description" component={textInput} icon="quote" placeholder="(Description)" forwardRef ref={ref => (this.descriptionRef = ref)} />

					<Field icon="person" name="supplier_id" emptyText=" - No supplier - " component={renderAutoComplete} data={suppliers} openAdder={this._toggleModal} />
					{this.props.vatReg && <Field name="net" label="Net" icon="pricetag" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />}
					{this.props.vatReg && <Field name="vat" label="VAT" icon="cut" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />}
					<Field name="payable" label="Payable" icon="pricetags" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} />
					<Field name="paid" label="Paid" icon="done-all" component={moneyInput} forwardRef ref={c => this.formRefs.push(c)} disabled={!!this.props.initialValues?.setransaction_id} />
					{!!this.props.showAccts && (
						<Field
							name="account_id"
							label="From"
							component={renderPicker}
							icon="open"
							labelWidth="30%"
							style={{ flex: 1 }}
							prompt="Select account"
							mode="dropdown"
							emptyText=" - Choose Account - "
							disabled={!!this.props.initialValues?.setransaction_id}>
							{accounts.map((item, i) => (
								<Picker.Item key={i} label={item.nickName} value={item.id} />
							))}
						</Field>
					)}
					{!!this.props.initialValues?.setransaction_id && (
						<Text note style={{ textAlign: 'right' }}>
							Imported from bank
						</Text>
					)}
					{!!recurring && (
						<Card style={{ marginRight: 5 }}>
							<CardItem style={{ flexDirection: 'column' }}>
								<Icon name="refresh-circle" style={{ alignSelf: 'center', color: '#438eb9' }} />
								<H3 style={{ alignSelf: 'center', color: '#438eb9' }}>Recurring Expense</H3>

								<Text>You are editing an expense that's part of a series. (Recurs every {recurring.replace('P', '')})</Text>
								<Field name="editFuture" labelType="fixed" label="Edit ..." offVal="Just this" onVal="This and future" component={renderSwitch} />
							</CardItem>
						</Card>
					)}
					{canRecur && (
						<View style={{ flexDirection: 'column', marginRight: 5 }}>
							<ListItem style={{ marginLeft: 2, paddingTop: 7, paddingBottom: 7, width: '100%' }}>
								<Icon name="refresh-circle" size={14} style={{ fontSize: 18, alignSelf: 'center', color: '#2f6483', marginRight: 10 }} />
								<Label style={{ flex: 1, marginLeft: 5, color: '#2f6483' }}>{wantRecurring ? 'Repeating' : 'Not repeating'}</Label>
								<Switch value={wantRecurring} onValueChange={this._toggleRepeating} style={{ flex: null }} />
							</ListItem>
							{!!wantRecurring && (
								<Card>
									<CardItem style={{ flexDirection: 'column' }}>
										<Text>Repeats every</Text>
										<View style={{ flexDirection: 'row' }}>
											<Button transparent onPress={() => (this.state.periodNum > 1 ? this._changePeriodNum(this.state.periodNum - 1) : null)}>
												<Icon name="remove" />
											</Button>
											<TextInput
												selectTextOnFocus
												keyboardType={'numeric'}
												style={{ flex: 0.5, textAlign: 'center', fontSize: 20, maxWidth: 80 }}
												onChangeText={this._changePeriodNum}
												value={this.state.periodNum.toString()}
											/>
											<Button transparent onPress={() => this._changePeriodNum(this.state.periodNum + 1)}>
												<Icon name="add" />
											</Button>
											<Picker prompt="Select frequency" iosHeader={'Select Frequency'} style={{ flex: 2 }} ref="input" selectedValue={this.state.periodFreq} onValueChange={this._changePeriodFreq}>
												<Picker.Item key={0} label={this.state.periodNum == 1 ? 'Month' : 'Months'} value="M" />
												<Picker.Item key={1} label={this.state.periodNum == 1 ? 'Day' : 'Days'} value="D" />
												<Picker.Item key={2} label={this.state.periodNum == 1 ? 'Year' : 'Years'} value="Y" />
											</Picker>
										</View>
									</CardItem>
								</Card>
							)}
							<Field name="series_freq" style={{ display: 'none' }} component={displayInput} />
						</View>
					)}
				</Form>
			);
		}
	}

	//editable: {'$set':values.setransaction_id<=1}

	_reduceToEnum(dataWithId, field = 'display') {
		const data = dataWithId.reduce(function (result, current) {
			result[current.id] = current[field];
			return result;
		}, {});
		return data;
	}

	_toggleModal = name =>
		//this._changeFormVal('customer_id', Number(55).toString());
		this.setState({ adding: !this.state.adding, addingName: name });

	_toggleExpenseTypes = () => this.setState({ expenseing: !this.state.expenseing });

	_toggleRepeating = () => {
		//if switching off, unset series_freq
		const f = this.state.periodFreq,
			n = this.state.periodNum;
		this._changeFormVal('series_freq', this.state.wantRecurring ? null : `P${n}${f}`);
		this.setState({ wantRecurring: !this.state.wantRecurring, periodNum: 1, periodFreq: 'M' });
	};
	_changePeriodNum = v => {
		const f = this.state.periodFreq;
		this._changeFormVal('series_freq', `P${v}${f}`);
		this.setState({ periodNum: v });
	};
	_changePeriodFreq = v => {
		const n = this.state.periodNum;
		this._changeFormVal('series_freq', `P${n}${v}`);
		this.setState({ periodFreq: v });
	};

	preSaveValidate(values) {
		//check date
		/*if (theRec.get('paid') != 0 && !theRec.get('account_id')) {
            form.getForm().markInvalid({
                account: 'Which account was this paid to?'
            });
            return false;
        }
        var vatRate = this.getViewModel().get('busDetails.vatRate');

        if (theRec.get('net') > 0 && theRec.get('vat') > (theRec.get('net') * vatRate / 100 + 0.05)) {
            form.getForm().markInvalid({
                vat: 'VAT is more than ' + vatRate + '% of net'
            });
            return false;
        }

        if (
			((theRec.get('payable') > 0 &&
				theRec.get('paid') < theRec.get('payable'))
			|| (theRec.get('payable') < 0 &&
				theRec.get('paid') > theRec.get('payable'))
			)
			&& !this.lookupReference('newReceiptCust').value) {
				form.getForm().markInvalid({
					newReceiptCust: 'Transaction not fully paid: Who owes you this money?'
				});
				return false;
        }

        if (
			((theRec.get('payable') > 0 &&
				theRec.get('paid') > theRec.get('payable'))
			|| (theRec.get('payable') < 0 &&
				theRec.get('paid') < theRec.get('payable'))
			)
			&& !this.lookupReference('newReceiptCust').value) {
				form.getForm().markInvalid({
					newReceiptCust: 'Overpaid receipt. Who do you owe this money to?'
				});
				return false;
        }

        if (theRec.get('paid') ==0 && theRec.get('payable') ==0) {
            form.getForm().markInvalid({
                newPaid: 'Zero receivable and received. Press cancel or enter an amount'
            });
            return false;
        }*/
	}

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val, this.props);
		this.props.dispatch(change('DEform', field, val));
		//this.props.dispatch(change('DEform', 'description', 'TEST'));
	}

	_personAddClosed(id) {
		__DEV__ && console.log('personAddClosed', id);
		if (typeof id == 'object') return;
		this.setState({ adding: false });
		const toChange = this.props.transType == 'receipt' ? 'customer_id' : 'supplier_id';

		if (id) setTimeout(this._changeFormVal.bind(this, toChange, id.toString()), 500); //only works non-debug!
	}

	_expenseClosed(id) {
		this.setState({ expenseing: false });
		if (this.descriptionRef) this.descriptionRef.getRenderedComponent().refs.input._root.focus();
		//change the form field to correct value (via redux)
		if (id) setTimeout(this._changeFormVal.bind(this, 'expenseCategory_id', id.toString()), 500); //only works non-debug!
	}

	_camClosed(pic64, otherdata) {
		//console.log(pic64);
		this.setState({ camming: false, pic: pic64 });
		if (pic64) {
			//FileSystem.readAsStringAsync(pic).then(data => {
			this._changeFormVal('pic', pic64);
			if (otherdata.total) {
				this._changeFormVal('payable', otherdata.total);
				this._changeFormVal('paid', otherdata.total);
				this._changeFormVal('net', otherdata.total);
			}
			if (otherdata.date) this._changeFormVal('expenseDate', otherdata.date);
		}
	}

	render() {
		const { handleSubmit, pristine, reset, submitting } = this.props;
		__DEV__ && console.log('DEform PROPS  ', this.props, this.state);
		const { customers, suppliers, categories, accounts } = this.props;

		var content = this.makeForm(suppliers, customers, categories, accounts);
		//console.log('formRefs', this.formRefs);
		//console.log('render form', this);

		return (
			<View style={{ flex: 1 }}>
				{this.state.adding && (
					<PersonForm
						closure={id => {
							this._personAddClosed(id);
						}}
						personType={this.props.transType == 'receipt' ? 'customer' : 'supplier'}
						name={this.state.addingName}
					/>
				)}
				{this.state.expenseing && (
					<ExpenseTypeContainer
						closure={id => {
							this._expenseClosed(id);
						}}
						swapToAsset={this.props.isNew && this.props.swapToAsset}
					/>
				)}
				{this.state.camming && <DECamera closure={(pic, data) => this._camClosed(pic, data)} autoPermissions />}
				<Content padder keyboardShouldPersistTaps={'handled'}>
					{content}
				</Content>

				<FormFooter formRefs={this.formRefs} updateVal={this._changeFormVal.bind(this)} />
			</View>
		);
	}
}

export default reduxForm({
	form: 'DEform',
	validate: syncValidate,
	asyncValidate: asyncValidate,
	asyncBlurFields: ['net', 'vat', 'payable', 'paid'] //cause a re-render
})(DEform);
